import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class BudgetSourceAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'BudgetSources';

  /**
   * Get dữ liệu chuyển từ nguồn
   * @returns
   */
  async fromBudgetSource(param = {}) {
    const apiUrl = this.getAPIUrl();

    const request = {
      url: apiUrl + '/list',
      data: {
        Skip: 0,
        Take: 100,
        Sort: 'budget_source_code',
        Columns: 'budget_source_name,budget_source_code,budget_source_id',
        Filter: '[{"Field":"parent_id","Operator":"NOT NULL"}]',
        type: 0,
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Get dữ liệu chuyển từ nguồn
   * @returns
   */
  async changeBudgetSource(param) {
    const apiUrl = this.getAPIUrl();

    const request = {
      url: apiUrl + '/changeBudgetSource',
      data: {
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Chuyển dữ liệu dữu liệu danh mục nguồn kinh phí
   * @author nnninh 02/06/2023
   * @param {*} payload
   * @returns
   */
  async updateBudgetSourceData(payload) {
    const request = {
      url: this.getAPIUrl() + '/tranferData',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Get dữ liệu chuyển từ nguồn
   * @returns
   */
  async GetAccountDefaultByBudgetSource(budgetSourceId) {
    const request = {
      url: [this.getAPIUrl(), `GetAccountDefaultByBudgetSource?BudgetSourceId=${budgetSourceId}`].join('/'),
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Lấy nguồn kinh phí chi tiết
   * @returns
   */
  async getBudgetSourceMappingToExport() {
    const request = {url: [this.getAPIUrl(), 'budgetSourceMappingToExport'].join('/')};
    return await httpClient.getAsync(request);
  }

  /**
   * Lưu danh mục nguồn mapping
   * @param {*} data
   * @returns
   */
  async savebudgetSourceMappingToExport(data) {
    const request = {
      url: [this.getAPIUrl(), 'savebudgetSourceMappingToExport'].join('/'),
      data: {
        Data: data,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Chuyển dữ liệu dữu liệu list danh mục
   * ntban - 4.7.2023
   */
  async updateTranferListData(payload) {
    const request = {
      url: this.getAPIUrl() + '/tranferListData',
      data: payload,
    };
    return await httpClient.postAsync(request, true);
  }
}

export default new BudgetSourceAPI();
